import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SelectComponent } from './select.component';
import { VarDirectiveModule } from '../../directives/ng-var';

@NgModule({
    imports: [
        CommonModule,
        VarDirectiveModule
    ],
    exports: [SelectComponent],
    declarations: [SelectComponent],
    providers: [],
})
export class SelectModule { }
